import { ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS } from "@softline/application";
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from "@softline/ui-core";
import { Store } from "@softline/core";
import { inject, provideEnvironmentInitializer } from "@angular/core";
import { default as de } from "../i18n/de.json";
import { SOFTLINE_PERMISSION_UPLOAD_ARCHIVE_VOUCHER } from "./archivbeleg-upload.shared";

export const archivbelegUploadProviders = [
  provideEnvironmentInitializer(() => {
      const store = inject(Store);
      store.commit(
        SOFTLINE_FEATURE_TRANSLATION,
        TranslationStore.mutations.add,
        {
          module: 'archivbeleg',
          language: 'de',
          translations: de,
        }
      );
      store.commit(
        SOFTLINE_FEATURE_APPLICATIONS,
        ApplicationStore.mutations.add,
        {
          name: 'Archivbeleg hochladen',
          icon: 'fa-regular fa-file-arrow-up',
          route: '/archivbeleg',
          permission: SOFTLINE_PERMISSION_UPLOAD_ARCHIVE_VOUCHER,
        }
      );
    }),
];
